import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";

// Components
import Home from "./components/Home";
import History from "./components/History";
import Contact from "./components/Contact";
import Menu from "./components/Menu";
import SiteFooter from "./components/SiteFooter";
import TermsAndConditions from "./components/TermsAndConditions";
import Administration from "./components/Administration";
import Accommodation from "./components/Accommodation";
import Timing from "./components/Timing";
import MainnMenu from "./components/MainMenu";
import Attract from "./components/Attract";
import PhotoGallery from "./components/PhotoGallery";
import Live from "./components/Live";
import Slider from "./components/Slider";
import NewsEvents from "./components/NewsEvents";
import Lakshadeepam from "./components/Lakshadeepam";
import DressCode from "./components/DressCode";
import AboutKiosk from "./components/AboutKiosk";
import TimingKiosk from "./components/TimingKiosk";

/* ---------------- Layout Component ---------------- */
function Layout({ children }) {
  const location = useLocation();

  // Routes where header & footer should be hidden
  const hideLayoutRoutes = ["/dresscode", "/aboutkiosk","/timingkiosk"];

  const hideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!hideLayout && (
        <header className="header">
          <MainnMenu />
        </header>
      )}

      {/* Page Content */}
      {children}

      {!hideLayout && (
        <footer
          className="footer"
          style={{
            backgroundImage: "url(./images/spst.webp)",
            padding: "0px"
          }}
        >
          <SiteFooter />
        </footer>
      )}
    </>
  );
}

/* ---------------- App Component ---------------- */
function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/history" element={<History />} />
          <Route path="/accommodation" element={<Accommodation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/administration" element={<Administration />} />
          <Route path="/timing" element={<Timing />} />
          <Route path="/attract" element={<Attract />} />
          <Route path="/gallery" element={<PhotoGallery />} />
          <Route path="/live" element={<Live />} />
          <Route path="/slider" element={<Slider />} />
          <Route path="/newsevents" element={<NewsEvents />} />
          <Route path="/lakshadeepam" element={<Lakshadeepam />} />

          {/* Pages WITHOUT Header & Footer */}
          <Route path="/dresscode" element={<DressCode />} />
          <Route path="/aboutkiosk" element={<AboutKiosk />} />
		  <Route path="/timingkiosk" element={<TimingKiosk />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
